/**
 * Org-scoped managed job URLs (basename-tolerant: match segment anywhere in pathname).
 */
export const EMPLOYER_ORG_SCOPED_JOBS_SEGMENT_RE =
  /\/employer\/organisations\/[^/]+\/jobs(?:\/|$)/

/** Singular profile route: `/employer/organisation/:slug` (see `employer-routes.tsx`). */
export const EMPLOYER_ORGANISATION_PROFILE_SEGMENT_RE =
  /\/employer\/organisation\/[^/]+(?:\/|$)/

const isNavActive = (pathname: string, path: string) =>
  pathname === path || (path !== '/' && pathname.startsWith(`${path}/`))

/** Mirrors `EMPLOYER_ORGANISATION_HUB_PATH` in UI `constants/index.ts` (local literal avoids importing Vite client bundle into Node tests). */
const EMPLOYER_ORGANISATION_HUB_NAV_PATH = '/employer/organisation'

/**
 * Employer sidebar active state.
 * - Job openings: flat `/employer/jobs` plus org-scoped managed jobs under plural `organisations`.
 * - Organisation hub (singular `/employer/organisation`): hub + profile slug subtree; never org-scoped jobs under plural path.
 * - My organisations (legacy nav path): plural `/employer/organisations` subtree **except** org-scoped job URLs (those belong to Job openings).
 * - Organisation profile uses singular `organisation`; treat as organisations nav active when item path is plural list.
 */
export function employerSidebarNavItemActive(
  pathname: string,
  item: { path: string; exact: boolean },
): boolean {
  if (item.exact) {
    return pathname === item.path || pathname === `${item.path}/`
  }
  if (item.path === '/employer/jobs') {
    if (pathname === '/employer/jobs' || pathname.startsWith('/employer/jobs/')) {
      return true
    }
    return EMPLOYER_ORG_SCOPED_JOBS_SEGMENT_RE.test(pathname)
  }
  if (item.path === EMPLOYER_ORGANISATION_HUB_NAV_PATH) {
    if (EMPLOYER_ORG_SCOPED_JOBS_SEGMENT_RE.test(pathname)) return false
    return isNavActive(pathname, EMPLOYER_ORGANISATION_HUB_NAV_PATH)
  }
  if (item.path === '/employer/organisations') {
    if (EMPLOYER_ORG_SCOPED_JOBS_SEGMENT_RE.test(pathname)) return false
    if (EMPLOYER_ORGANISATION_PROFILE_SEGMENT_RE.test(pathname)) return true
    return isNavActive(pathname, item.path)
  }
  return isNavActive(pathname, item.path)
}
